<h3 class="ui primary header" style="text-transform: capitalize">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="content">
  <div
    class="scroll-wrapper ui basic segment"
    appMargin="0"
    appPadding="0"
    [ngClass]="{ loading: pending }"
  >
    <div *ngIf="success || error" appMargin marginY="10px">
      <esl-message-toast [(message)]="error"></esl-message-toast>
      <esl-message-toast
        [(message)]="success"
        [messageType]="'success'"
      ></esl-message-toast>
    </div>
    <div class="ui basic segment" fxLayout="column" fxLayoutGap="20px">
      <div fxLayout="row">
        <div fxFlex>
          <img
            *ngIf="documentData"
            src="{{ documentData }}"
            class="ui mini image image-large"
          />
          <img
            *ngIf="!documentData"
            src="assets/avatar/1.jpg"
            class="ui circular tiny image"
          />
        </div>
      </div>

      <div fxLayout="column">
        <div fxFlex>
          <div class="heading-text">Firstname</div>
        </div>
        <div fxFlex class="heading-bottom">
          {{ detail?.director?.firstName }}
        </div>
      </div>

      <div fxLayout="column">
        <div fxFlex>
          <div class="heading-text">Lastname</div>
        </div>
        <div fxFlex class="heading-bottom">
          {{ detail?.director?.lastName }}
        </div>
      </div>

      <div fxLayout="column">
        <div fxFlex>
          <div class="heading-text">Middlename</div>
        </div>
        <div fxFlex class="heading-bottom">
          {{ detail?.director?.middleName }}
        </div>
      </div>

      <div fxLayout="column">
        <div fxFlex>
          <div class="heading-text">Gender</div>
        </div>
        <div fxFlex class="heading-bottom">{{ detail?.director?.gender }}</div>
      </div>

      <div fxLayout="column">
        <div fxFlex>
          <div class="heading-text">Nationality</div>
        </div>
        <div fxFlex class="heading-bottom">
          {{ detail?.director?.nationalityName }}
        </div>
      </div>

      <div fxLayout="column">
        <div fxFlex>
          <div class="heading-text">Country of Origin</div>
        </div>
        <div fxFlex class="heading-bottom">
          {{ detail?.director?.countryOfOriginName }}
        </div>
      </div>

      <div fxLayout="column">
        <div fxFlex>
          <div class="heading-text">National ID Number</div>
        </div>
        <div fxFlex class="heading-bottom">
          {{ detail?.director?.nationalIdNumber }}
        </div>
      </div>
      <div fxLayout="column">
        <div fxFlex>
          <div class="heading-text">Address</div>
        </div>
        <div fxFlex class="heading-bottom">
          {{ detail?.director?.address }}
        </div>
      </div>
      <div fxLayout="column">
        <div fxFlex>
          <div class="heading-text">Email</div>
        </div>
        <div fxFlex class="heading-bottom">
          {{ detail?.director?.email }}
        </div>
      </div>
      <div fxLayout="column">
        <div fxFlex>
          <div class="heading-text">Phone Number</div>
        </div>
        <div fxFlex class="heading-bottom">
          {{ detail?.director?.phoneNumber }}
        </div>
      </div>
      <div fxLayout="column" *ngIf="item == 'SHAREHOLDER_STRUCTURE'">
        <div fxLayout="column" style="margin-bottom: 20px">
          <div fxFlex>
            <div class="heading-text">Shareholder Type</div>
          </div>
          <div fxFlex class="heading-bottom">
            {{
              detail.director.companyName && detail.director.companyRegNumber
                ? "Company"
                : "Individual"
            }}
          </div>
        </div>
        <div
          *ngIf="
            detail.director.companyName && detail.director.companyRegNumber
          "
          fxLayout="column"
          style="margin-bottom: 20px"
        >
          <div fxFlex>
            <div class="heading-text">Company Name</div>
          </div>
          <div fxFlex class="heading-bottom">
            {{ detail?.director?.companyName }}
          </div>
        </div>
        <div
          *ngIf="
            detail.director.companyName && detail.director.companyRegNumber
          "
          fxLayout="column"
          style="margin-bottom: 20px"
        >
          <div fxFlex>
            <div class="heading-text">Company Registration Number</div>
          </div>
          <div fxFlex class="heading-bottom">
            {{ detail?.director?.companyRegNumber }}
          </div>
        </div>
        <div fxLayout="column" style="margin-bottom: 20px">
          <div fxFlex>
            <div class="heading-text">Shareholding amount</div>
          </div>
          <div fxFlex class="heading-bottom">
            {{ detail?.director?.shareholding }}%
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="actions">
    <button class="ui basic primary button" (click)="modal.deny(undefined)">
      Back
    </button>
    <!-- <button class="ui  primary button" [ngClass]="{'yellow':pending}" [disabled]="pending" (click)="save()" autofocus>Done</button> -->
  </div>
</div>
